import React, { useState, useMemo, useEffect, useRef, useContext } from "react";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Dropdown, Form, Nav, Navbar } from "react-bootstrap";
import Search_product_modal from "../common/modals/common-modal/search-product-modal/Search_product_modal";
import Login_modal from "../common/modals/login-signup-modals/Login_modal";
import Reset_Password_Modal from "../common/modals/login-signup-modals/Reset_Password_Modal";
import Set_New_Password_Modal from "../common/modals/login-signup-modals/Set_New_Password_Modal";
import Select_login from "../common/modals/login-signup-modals/Select_login";
import Select from "react-select";
import Login_Layout_Modal from "../common/modals/login-signup-modals/Login_Layout_Modal";
import Signup_Modal from "../common/modals/login-signup-modals/Signup_Modal";
import { getAllCart, postToLoginCart } from "../../features/cart/cartSlice";
import { Context } from "../../utils/context";
import { useDispatch, useSelector } from "react-redux";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import { AllLanguage } from "../../features/admin/common/Slice";
import Cookies from "js-cookie";
import { getNotifications, updateNotificationStatus } from "../../features/notifications/notificationSlice";

function Header() {
  const navigate = useNavigate();

  // State for search box toggle
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const [modalShow, setModalShow] = React.useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [signupModal, setSignupModal] = useState(false);
  const [selectLogin, setSelectLogin] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [showConfimLocModal, setShowConfimLocModal] = useState(false);
  const [isLogedIn, setIsLogedIn] = useState(false);
  const [modalType, setModalType] = useState("");
  const [expanded, setExpanded] = useState(false);

  const { signin } = useContext(Context);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState("");

  const languages = useSelector((state) => state.common.languages);


  useEffect(() => {
    dispatch(AllLanguage());
  }, [dispatch]);

  useEffect(() => {
    const savedLang = Cookies.get("language_id");
    if (savedLang) {
      setSelectedValue(Number(savedLang));
    }
  }, []);

  const searchRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchBox(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchRef]);

  useEffect(() => {
    const loginCart = async () => {
      if (signin) {
        await dispatch(postToLoginCart());
      }
      await dispatch(getAllCart(signin));
    };
    loginCart();
  }, [signin, dispatch]);

  const allCart = useSelector((state) => state.cart.allCarts);

  useEffect(() => {
    dispatch(getAllCart());
  }, [dispatch]);


  const notifications = useSelector((state) => state.notification);

  useEffect(() => {
    if (signin) {
      dispatch(getNotifications())
    }
  }, [signin]);


  return (
    <>
      <section className="header_sec">
        <div className="tophead">
          <div className="logosec" onClick={() => setExpanded(false)}>
            <Navbar.Brand as={Link} to="/home">
              <img
                className="logoimg"
                src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
                alt="logo-img"
              />

              <img
                className="leftwing"
                src={process.env.PUBLIC_URL + "/assets/images/header/left.png"}
                alt="left"
              />
              <img
                className="rightwing"
                src={process.env.PUBLIC_URL + "/assets/images/header/right.png"}
                alt="left"
              />
            </Navbar.Brand>
          </div>
        </div>

        <div className="two_sec">
          <div className="menu_sec">
            <Navbar
              expand="lg"
              className=""
              expanded={expanded}
              onToggle={() => setExpanded(!expanded)}
            >
              <div className="container">
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="mx-auto" onClick={() => setExpanded(false)}>
                    <Nav.Link
                      as={Link}
                      to={"/home"}
                      className={location.pathname === "/home" ? "active" : ""}
                    >
                      Om Tapovan
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to={"/gurudev"}
                      onClick={() => setExpanded(false)}
                      className={
                        location.pathname === "/gurudev" ? "active" : ""
                      }
                    >
                      Gurudev
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to={"/insight"}
                      onClick={() => setExpanded(false)}
                      className={
                        location.pathname === "/insight" ? "active" : ""
                      }
                    >
                      Insight
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to={"/explore"}
                      onClick={() => setExpanded(false)}
                      className={
                        location.pathname === "/explore" ? "active" : ""
                      }
                    >
                      Explore
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to={"/contact-us"}
                      onClick={() => setExpanded(false)}
                      className={
                        location.pathname === "/contact-us" ? "active" : ""
                      }
                    >
                      Contact Us
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to={"/spandan"}
                      onClick={() => setExpanded(false)}
                      className={
                        location.pathname === "/spandan" ? "active" : ""
                      }
                    >
                      Spandan
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to={"/donate"}
                      onClick={() => setExpanded(false)}
                      className={`${location.pathname === "/donate" ? "active" : ""
                        } hidden_nav`}
                    >
                      Donate
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to={"/volunteer"}
                      onClick={() => setExpanded(false)}
                      className={`${location.pathname === "/volunteer" ? "active" : ""
                        } hidden_nav`}
                    >
                      Be a Volunteer
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </div>
            </Navbar>
          </div>

          <div className="icon_sec">
            <Nav.Link>
              <div className="aftelogflex">
                <div className="logdiv">
                  <Nav.Link>
                    <div className="aftelogflex">
                      <div className="logdiv search_wrapper" ref={searchRef}>
                        {/* <Nav.Link
                          onClick={() => setShowSearchBox((prev) => !prev)}
                          className="search_icon_btn"
                        >
                          <img
                            className="icon"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/header/search.png"
                            }
                            alt="search-icon"
                          />
                        </Nav.Link> */}

                        {showSearchBox && (
                          <div className="search_box">
                            <Form.Control
                              type="text"
                              placeholder="Search..."
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value)}
                              autoFocus
                            />
                            <button
                              className="close_btn"
                              onClick={() => setShowSearchBox(false)}
                            >
                              ✕
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Nav.Link>
                </div>

                {signin ? (
                  <>
                    <div className="logdiv cart_div">
                      {allCart?.data?.data?.length > 0 && (
                        <div className="count_div">
                          <p className="count_text">
                            {" "}
                            {allCart?.data?.data?.length || 0}
                          </p>
                        </div>
                      )}

                      <Nav.Link as={Link} to={"/cart"}>
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/header/cart.png"
                          }
                          alt="cart-icon"
                        />
                      </Nav.Link>
                    </div>

                    <div className="logdiv cart_div">
                      {
                        notifications?.data?.total > 0 && (
                          <div className="count_div">
                            <p className="count_text">{notifications?.data?.total || "0"}</p>
                          </div>)
                      }
                      <Nav.Link as={Link} to={"/notification"}>
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/header/notification.png"
                          }
                          alt="notification-icon"
                        />
                      </Nav.Link>
                    </div>

                    <div className="logdiv">
                      <Nav.Link as={Link} to={"/profile"}>
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/header/profile.png"
                          }
                          alt="profile-icon"
                        />
                      </Nav.Link>
                    </div>

                    <div className="logdiv">
                      <Dropdown align="end">
                        <Dropdown.Toggle
                          as="div"
                          className="lang_dropdown_toggle"
                          id="lang-dropdown"
                        >
                          <img
                            className="icon lang_icon"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/header/lang.png"
                            }
                            alt="language"
                            style={{ cursor: "pointer" }}
                          />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {languages.map((lang) => (
                            <Dropdown.Item
                              key={lang.id}
                              onClick={() => {
                                navigate(0);
                                Cookies.set("language_id", lang.id, {
                                  expires: 365, // 1 year
                                });
                                setSelectedValue(lang.id);
                              }}
                              className={
                                selectedValue === lang.id ? "activeClass" : ""
                              }
                            >
                              {lang.name}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="logdiv cart_div">
                      {allCart?.data?.data?.length > 0 && (
                        <div className="count_div">
                          <p className="count_text">
                            {" "}
                            {allCart?.data?.data?.length || 0}
                          </p>
                        </div>
                      )}

                      <Nav.Link as={Link} to={"/cart"}>
                        <img
                          className="icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/header/cart.png"
                          }
                          alt="cart-icon"
                        />
                      </Nav.Link>
                    </div>
                    <div className="logdiv">
                      <Nav.Link className="m-0">
                        <button
                          className="loginbtn"
                          type="button"
                          onClick={() => {
                            setSelectLogin(true);
                            setModalType("select_login");
                            setRefreshKey((count) => count + 1);
                          }}
                        >
                          Login
                        </button>
                      </Nav.Link>
                    </div>

                    <div className="logdiv">
                      <Nav.Link>
                        <button
                          className="loginbtn"
                          type="button"
                          onClick={() => {
                            setSelectLogin(true);
                            setModalType("sign_up");
                            setRefreshKey((count) => count + 1);
                          }}

                        // onclick={() => setSignupModal(true)}
                        >
                          SignUp
                        </button>
                      </Nav.Link>
                    </div>
                  </>
                )}
              </div>
            </Nav.Link>
          </div>
        </div>

        <div className="floating_btns_holder">
          <button
            className="yellow_btn zoom_in_out"
            onClick={() => navigate("/donate")}
          >
            Donate
          </button>
          <button
            className="yellow_btn zoom_in_out"
            onClick={() => navigate("/volunteer")}
          >
            Be a Volunteer
          </button>
        </div>

        <Search_product_modal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />

        <Login_Layout_Modal
          modalType={modalType}
          show={selectLogin}
          onHide={() => setSelectLogin(false)}
        />

        {/* <Signup_Modal
          show={signupModal}
          onHide={() => setSignupModal(false)}
        /> */}
      </section>
    </>
  );
}

export default Header;
